<template>
  <div class="bind-page">
    <div class="section-title">{{ $t('message.home.accountBind') }}</div>

    <!-- 手机绑定 -->
    <div class="bind-card">
      <div class="bind-row">
        <span class="bind-icon">📱</span>
        <div class="bind-info">
          <div class="bind-name">{{ $t('message.home.mobileBind') }}</div>
          <div class="bind-current">{{ maskedMobile || $t('message.home.notBound') }}</div>
        </div>
        <el-button size="small" @click="openDialog('mobile')">
          {{ maskedMobile ? $t('message.home.change') : $t('message.home.bind') }}
        </el-button>
      </div>
    </div>

    <!-- 邮箱绑定 -->
    <div class="bind-card">
      <div class="bind-row">
        <span class="bind-icon">✉️</span>
        <div class="bind-info">
          <div class="bind-name">{{ $t('message.home.emailBind') }}</div>
          <div class="bind-current">{{ maskedEmail || $t('message.home.notBound') }}</div>
        </div>
        <el-button size="small" @click="openDialog('email')">
          {{ maskedEmail ? $t('message.home.change') : $t('message.home.bind') }}
        </el-button>
      </div>
    </div>

    <!-- 操作弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px">
      <el-form :model="bindForm" ref="bindForm" label-width="80px">
        <el-form-item v-if="bindType === 'mobile'" :label="$t('message.home.mobile')" prop="mobile">
          <el-input v-model="bindForm.mobile" :placeholder="$t('message.home.enterMobile')" />
        </el-form-item>
        <el-form-item v-if="bindType === 'email'" :label="$t('message.home.email')" prop="email">
          <el-input v-model="bindForm.email" :placeholder="$t('message.home.enterEmail')" />
        </el-form-item>
        <el-form-item :label="$t('message.home.verifyCode')" prop="code">
          <div style="display:flex;gap:8px">
            <el-input v-model="bindForm.code" :placeholder="$t('message.home.enterCode')" />
            <el-button :disabled="countdown > 0" @click="handleSendCode">
              {{ countdown > 0 ? countdown + 's' : $t('message.home.sendCode') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('message.home.cancel') }}</el-button>
        <el-button type="primary" @click="handleBind">{{ $t('message.home.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { load_member } from '@/api/upms/profile'
import { sendCode } from '@/api/upms/phone'

export default {
  name: 'AccountBind',
  data() {
    return {
      maskedMobile: '', maskedEmail: '',
      dialogVisible: false, bindType: 'mobile', countdown: 0,
      bindForm: { mobile: '', email: '', code: '' }
    }
  },
  computed: {
    dialogTitle() {
      return this.bindType === 'mobile' ? this.$t('message.home.mobileBind') : this.$t('message.home.emailBind')
    }
  },
  created() {
    load_member().then(r => {
      const m = r.data?.data?.member || {}
      if (m.mobile) this.maskedMobile = String(m.mobile).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      if (m.email) this.maskedEmail = String(m.email).replace(/(.{2}).+(@.+)/, '$1***$2')
    })
  },
  methods: {
    openDialog(type) {
      this.bindType = type
      this.bindForm = { mobile: '', email: '', code: '' }
      this.dialogVisible = true
    },
    handleSendCode() {
      const target = this.bindType === 'mobile' ? this.bindForm.mobile : this.bindForm.email
      if (!target) { this.$message.warning(this.$t('message.home.required')); return }
      sendCode({ mobile: this.bindType === 'mobile' ? target : undefined, email: this.bindType === 'email' ? target : undefined })
        .then(() => {
          this.$message.success(this.$t('message.home.codeSent'))
          this.countdown = 60
          const timer = setInterval(() => { this.countdown--; if (this.countdown <= 0) clearInterval(timer) }, 1000)
        })
    },
    handleBind() {
      if (!this.bindForm.code) { this.$message.warning(this.$t('message.home.required')); return }
      this.$message.success(this.$t('message.home.bindSuccess'))
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-page { padding: 8px 0; }
.section-title { font-size: 18px; font-weight: bold; margin-bottom: 20px; }
.bind-card { background: #fff; border: 1px solid #eee; border-radius: 8px; margin-bottom: 16px; padding: 20px 24px; }
.bind-row { display: flex; align-items: center; gap: 16px; }
.bind-icon { font-size: 28px; }
.bind-info { flex: 1; }
.bind-name { font-size: 15px; font-weight: bold; color: #303133; }
.bind-current { font-size: 13px; color: #909399; margin-top: 4px; }
</style>
